import { createElement, useState, useRef } from 'react';
import '../../index.scss';
import { EditableProTable as OriginalTable } from '@ant-design/pro-components';
const EditableProTable = (props) => {
    console.log(22, props);
    const actionRef = useRef();
    const formRef = useRef();
    const { actionColumn, actionColumnButtons, columns, requestUrl, onSave, onRemove, onCancel, position = 'bottom', ...otherProps } = props;
    const [editableKeys, setEditableRowKeys] = useState([]);
    const [dataSource, setDataSource] = useState(props.dataSource || []);
    function actionColumnButtonsHidden(showInEdit) {
        return ({ rowRecord }) => {
            return showInEdit ? !!rowRecord.editMode : !rowRecord.editMode;
        };
    }
    const defaultActionColumnButtons = [
        {
            name: '编辑',
            type: 'link',
            key: 'editable',
            onClick(e, payload) {
                const { action, record } = payload;
                action?.startEditable?.(record.id);
            },
            hidden: actionColumnButtonsHidden(true),
        },
        {
            children: '删除',
            type: 'link',
            onClick(e, payload) {
                const { rowIndex, record } = payload;
                setDataSource(dataSource.filter((item) => item.id !== record.id));
                onRemove && onRemove(rowIndex, record, dataSource);
            },
        },
    ];
    function runColumnActionCallback(param) {
        const { callback, text, record, _, action } = param;
        try {
            if (callback) {
                return Promise.resolve(callback(text, record, _, action));
            }
        }
        catch (e) {
            if (e instanceof Error) {
                console.warn(e.stack);
            }
        }
        return Promise.reject();
    }
    ;
    const renderActionColumnButtons = (actionColumn, actionColumnButtons) => {
        const { dataSource, visibleButtonCount } = actionColumnButtons;
        const totalButtons = [...defaultActionColumnButtons, ...dataSource];
        const showMoreAction = totalButtons.length > visibleButtonCount;
        const actionColumnButtonsToRender = totalButtons.slice(0, (showMoreAction ? visibleButtonCount - 1 : undefined));
        const remainActions = totalButtons.slice(visibleButtonCount - 1);
        const menu = remainActions.map((action) => {
            return {
                key: action.key,
                name: action.name,
                onClick: action.onClick
            };
        });
        return {
            ...actionColumn,
            valueType: 'option',
            key: 'option',
            width: actionColumn.width,
            render: (text, record, _, action) => {
                return [createElement("a", { key: "editable", onClick: () => {
                            console.log('link', text, record, _, action);
                            action?.startEditable?.(record.id);
                        } }, "\u7F16\u8F91"),
                    createElement("a", { key: "delete", onClick: () => {
                            setDataSource(dataSource.filter((item) => item.id !== record.id));
                        } }, "\u5220\u9664")];
            }
        };
    };
    const renderColunms = (columns) => {
        const _actionColumnButtons = renderActionColumnButtons(actionColumn, actionColumnButtons);
        const _columns = columns.map(column => {
            return column;
        });
        return [..._columns, _actionColumnButtons];
    };
    return (createElement(OriginalTable, Object.assign({ actionRef: actionRef, formRef: formRef, columns: renderColunms(columns), scroll: {
            x: 960,
        }, recordCreatorProps: position !== 'hidden'
            ? {
                position: position,
                record: () => ({ id: (Math.random() * 1000000).toFixed(0) }),
            }
            : false, value: dataSource, onChange: ({ values }) => setDataSource(values), editable: {
            type: 'multiple',
            editableKeys,
            onSave: async (rowKey, data, row) => {
                console.log(rowKey, data, row);
            },
            onChange: setEditableRowKeys,
        } }, otherProps)));
};
export default EditableProTable;
